import React, { useEffect, useLayoutEffect, useState } from 'react';
import { Fragment } from 'react';
import { StateModel, store } from '../../redux/store';
import { connect } from 'react-redux';

import { Message } from '../../api';
import { isOutOfViewport } from '../../utils/objectUtils';
import { removeNotification } from '../../utils/notificationUtils';

interface ValidationTipProps {
  children: React.ReactNode;
  classes?: string;
  fieldName: string;
  notifications: any;
  showTip?: boolean;
  markBackground?: boolean;
  activeNotificationComponent?: string;
  focusAfterRender?: () => void;
  elementValue?: string | number | undefined;
}

const ValidationTip = (props: ValidationTipProps) => {
  const [show, setShow] = useState<boolean>(false);
  const [message, setMessage] = useState<Message | undefined>(undefined);

  useEffect(() => {
    if (props.focusAfterRender) props.focusAfterRender();
  });
  useEffect(() => {
    props.fieldName && setMessage(findNotificationByFieldName(props.fieldName));
  }, [props.notifications.messageList]);

  useEffect(() => {
    message ? setShow(true) : setShow(false);
  }, [message]);

  useEffect(() => {
    if (show) {
      setShow(false);
      if (message && message.id) removeNotification(message.id);
    }
  }, [props.elementValue]);

  const onClickHandler = () => {
    setShow(false);
  };

  const findNotificationByFieldName = (fieldName: string) => {
    if (
      !props.notifications.activeComponent ||
      props.notifications.activeComponent == props.activeNotificationComponent
    ) {
      const notification = [...props.notifications.messageList].filter(
        notification => notification.fieldname === fieldName
      );
      return notification && notification[0];
    } else {
      return undefined;
    }
  };

  useEffect(() => {
    if (show) {
      const validationTips = document.getElementsByClassName('validationtip');
      for (let i = 0; i < validationTips.length; i++) {
        const isOut = isOutOfViewport(validationTips.item(i));
        if (isOut.any) {
          validationTips.item(i)?.classList.add('top');
        }
      }
    }
  }, [props.notifications.messageList, show]);

  return show ? (
    <Fragment>
      {props.showTip && (
        <div
          title={message?.header}
          className={`${props.classes} validationtip`}
        >
          {(message?.header || (message?.message && !message?.header)) && (
            <span className={'title'}>
              <i className='fas fa-exclamation-circle fa-sm' />
              {message?.header ? message?.header : message?.message}
              <span className={'validationButton'} onClick={onClickHandler}>
                <i className='fas fa-times fa-xs' />
              </span>
            </span>
          )}

          {message?.message && message?.header && (
            <Fragment>
              <span className={'message'}>{message?.message}</span>
            </Fragment>
          )}
        </div>
      )}
      <div style={props.markBackground ? { background: '#fde3e3' } : undefined}>
        {props.children}
      </div>
    </Fragment>
  ) : (
    <Fragment>{props.children}</Fragment>
  );
};

ValidationTip.defaultProps = {
  showTip: true,
  markBackground: false,
};

const mapStateToProps = (state: StateModel) => ({
  notifications: state.Notifications,
});

export default connect(mapStateToProps, {})(ValidationTip);
